const CONFIG = {
  PLACEHOLDER: "Enter case code",
  NO_CONTENT_TEXT: "no content",
  INVALID_CASE_TEXT: "invalid case"
};
export default CONFIG;
